import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12" aria-label="行动召唤">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-3xl overflow-hidden">
          {/* 左侧：图像区 */}
          <div className="relative bg-[#1C1C1E] min-h-[350px] lg:min-h-[500px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20immersive%20reading%20scene%2C%20cozy%20person%20reading%20comics%20on%20a%20tablet%20in%20a%20warm%20lit%20room%2C%20soft%20ambient%20lighting%2C%20warm%20coral%20and%20beige%20tones%2C%20comfortable%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20lifestyle%20mood&width=900&height=700&seq=cta-comic-scene&orientation=landscape"
              alt="随时随地畅享韩漫阅读"
              title="韩国漫画网 - 开始你的阅读之旅"
              className="w-full h-full object-cover object-center"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-black/30"></div>

            {/* 左下角标签和标题 */}
            <div className="absolute left-6 bottom-6">
              <p className="text-white/60 text-xs mb-3 tracking-widest">KMANHUA</p>
              <p className="text-white font-black text-3xl md:text-5xl leading-tight">
                随时随地
                <br />
                畅享<span className="text-comic-primary">韩漫</span>
              </p>
            </div>
          </div>

          {/* 右侧：行动区 */}
          <div className="bg-white flex flex-col items-center justify-center text-center p-10 md:p-16">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight mb-6">
              开始你的
              <br />
              阅读之旅
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-sm leading-relaxed mb-10">
              数千部精选韩漫等你发现。无需注册，打开即看，随时随地沉浸在精彩绝伦的漫画世界中。现在就开启属于你的阅读冒险吧！
            </p>
            <Link
              to="/category/school-romance"
              className="px-10 py-4 rounded-full bg-comic-primary text-white font-bold text-sm hover:bg-comic-primary-hover transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              立即探索
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}